module.exports = __webpack_public_path__ + "img/feature-grid.3b7df30a.png";